// Store setup
export const UPDATE_API = 'UPDATE_API';
export const ADD_API = 'ADD_API';
export const SET_ASSETS_ROOT = 'SET_ASSETS_ROOT';
export const SET_API_KEYS = 'SET_API_KEYS';


// Shake and Win Contest
export const SET_SDG_PROJECTS = 'SET_SDG_PROJECTS';
export const SET_SDG_CURRENT_PAGE = 'SET_SDG_CURRENT_PAGE';
export const SET_SDG_COUNT = 'SET_SDG_COUNT';
export const SET_SDG_PREV = 'SET_SDG_PREV';
export const SET_SDG_NEXT = 'SET_SDG_NEXT';
export const SET_SDG_RAISED = 'SET_SDG_RAISED';
export const SET_SDG_NUM_PROJECTS = 'SET_SDG_NUM_PROJECTS';
export const SET_SDG_IDENTIFIER = 'SET_SDG_IDENTIFIER';
export const SET_SDG_COMMUNITY = 'SET_SDG_COMMUNITY';
